<template>
  <div class="dashboard">
    <AddressWarning />
    <div class="container">
      <div class="columns">
        <div class="column is-6">
          <Balance />
        </div>
        <div class="column is-6">
          <QuickOrder />
        </div>
      </div>
      <hr />
      <div class="columns">
        <div class="column">
          <RecentStatement/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Balance from "./Balance";
import QuickOrder from "./QuickOrder";
import RecentStatement from "../reports/RecentStatement";
import AddressWarning from "../../components/AddressWarning";

export default {
  name: "Dashboard",
  components: {
    Balance,
    QuickOrder,
    RecentStatement,
    AddressWarning
  }
};
</script>

<style scoped></style>
